import * as React from "react";
import Flexbox from "flexbox-react";
import axios from "axios";
import Pagination from "react-js-pagination";
import { Spinner, Tooltip, Position } from "@blueprintjs/core";
import Cookies from "js-cookie";
import ThemeWrapper from "../components/styles/ThemeWrapper/index.js";
import ErrorBoundary from "../components/errors/ErrorBoundary";
import Utilities from "../utils/Utilities";
import ScrollableDropdown from "../components/shared/ScrollableDropdown.jsx";
import { InputGroup } from "@blueprintjs/core";
import ToastStore from "../stores/ToastStore";
import "./UsersGoalsViewTable.css";
import FilledButton from "../components/buttons-20250224T111359Z-001/buttons/FilledButton.jsx";
import OutlinedButton from "../components/buttons-20250224T111359Z-001/buttons/OutlinedButton.jsx";
import { Checkbox } from "@blueprintjs/core";
import GoalTableInfoCard from "../components/goals/GoalTableInfoCard";
import TotalEmployees from "../assets/TotalEmployees.svg";
import TotalGoals from "../assets/TotalGoals.svg";
import EmployeeWithoutGoal from "../assets/EmployeeWithoutGoal.svg";
import EmpNotUpdatedGoal from "../assets/EmpNotUpdatedGoal.svg";



const GOAL_TABLE_STYLES = `
.table-row {
  line-height: 24px;
  transition: background-color 0.2s ease-in-out;
}
.table-row:hover {
  background-color: #f5f5f5;
}
.status-row {
  align-items: center;
  text-align: center;
  justify-content: center;
} 
.status-row span {
  padding: 8px 20px;
  border-radius: 50px;
  text-align: center;
} 
.title-row {
  text-decoration: none;
}
.ellipsis-text {
  max-width: 250px; 
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  display: inline-block;
} 
table.bp3-html-table thead th.table-header-text, 
tbody td.table-header-text,
tbody td.span.table-header-text {
  color: #4D4D4D;
  font-family: Roboto;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
}
.table-header-text {
  color: #4D4D4D;
  font-family: Roboto;
  font-size: 18px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
}
.goal-table-container {
  width: 100%;
  overflow-x: auto;
}
.goal-table-container table {
  width: 100%;
  border-collapse: collapse;
}
`;

export default class UsersGoalsViewTable extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            searchQuery: "",
            employeeSummary: [],
            goalCycleList: [],
            selectedUsers: [],
            selectedUserCount: 0,
            isSendingMails: false,
            selectedTimeframe: {},
            isDropdownOpen: false,
            error: null,
            isLoadingCycles: false,
            isLoadingUsers: false,
            currentPage: 1,
            perPage: 10,
            totalUsers: 0,
            totalPages: 0,
            categories: [],
            selectedCategory: null,
            isLoadingCategories: false,
            goalInfoCardSummary: {
                totalEmployees: 0,
                totalGoals: 0,
                employeesWithoutGoals: 0,
                employeesGoalsNotUpdated: 0
            }
        };

        this.goalCycleDropdownRef = React.createRef();
        this.searchTimeout = null;
    }

    componentDidMount() {
        this.fetchCategories();
        this.getAllGoalCycleList()
            .then(() => {
                this.fetchGoalsForSelectedEmployeeCycle();
            })
            .catch(err => {
                console.error("Failed to load goal cycles", err);
            });
    }

    componentWillUnmount() {
        if (this.searchTimeout) {
            clearTimeout(this.searchTimeout);
        }
    }

    handleRowClick = row => {
        const { selectedTimeframe } = this.state;

        const userId = row.userId || row.id;
        const goalSettingId = selectedTimeframe?.id;

        if (!userId || !goalSettingId) {
            console.error("Missing userId or goalSettingId", { row, selectedTimeframe });
            return;
        }

        const payload = {
            u: userId,
            g: goalSettingId
        };

        const encoded = btoa(JSON.stringify(payload));

        Cookies.set("selectedEmployeeId", userId);
        Cookies.set("selectedEmployeeName", row.name);
        Cookies.set("selectedGoalCycleId", goalSettingId);

        sessionStorage.setItem("team_goals_context", JSON.stringify({
            userId: userId,
            goalSettingId: goalSettingId
        }));

        Utilities.navigate(`/goals/peer?r=${encodeURIComponent(encoded)}`);
    };

    handleSearchChange = e => {
        const searchQuery = e.target.value;
        this.setState({ searchQuery, currentPage: 1 });

        if (this.searchTimeout) {
            clearTimeout(this.searchTimeout);
        }

        this.searchTimeout = setTimeout(() => {
            this.fetchGoalsForSelectedEmployeeCycle(1);
        }, 500);
    };

    handleSearchKeyPress = e => {
        if (e.key === "Enter") {
            this.setState({ currentPage: 1 }, () => {
                this.fetchGoalsForSelectedEmployeeCycle(1);
            });
        }
    };
    getAllGoalCycleList = () => {
        this.setState({ isLoadingCycles: true });

        return new Promise((resolve, reject) => {
            axios
                .get(`${Cookies.get("apiEnv")}/goal_settings/goal_cycle_list`)
                .then(response => {
                    const goalCycleList = response.data || [];

                    if (goalCycleList.length > 0) {
                        this.setState(
                            {
                                goalCycleList,
                                selectedTimeframe: goalCycleList[0],
                                isLoadingCycles: false
                            },
                            resolve
                        );
                    } else {
                        this.setState(
                            { goalCycleList: [], selectedTimeframe: {}, isLoadingCycles: false },
                            resolve
                        );
                    }
                })
                .catch(error => {
                    this.setState({ error: "Failed to load", isLoadingCycles: false });
                    reject(error);
                });
        });
    };

    fetchCategories = async () => {
        const baseUrl = Cookies.get("apiEnv");
        if (!baseUrl) return;

        this.setState({ isLoadingCategories: true });

        try {
            const response = await axios.get(`${baseUrl}/question_categories`);
            const categories = Array.isArray(response.data) ? response.data : [];

            const categoriesWithAll = [
                { id: null, name: "All Departments" },
                ...categories
            ];

            this.setState({
                categories: categoriesWithAll,
                selectedCategory: categoriesWithAll[0]
            });
        } catch (e) {
            const message =
                e?.response?.data?.error?.join?.(", ") ||
                e?.response?.data?.error ||
                "Unable to load categories";
            ToastStore?.showToast?.(message, "danger");
        } finally {
            this.setState({ isLoadingCategories: false });
        }
    };

    getDefaultAvatar = name => {
        const initials = (name || "pg").substring(0, 2).toLowerCase();
        return `https://cdn.auth0.com/avatars/${initials}.png`;
    };

    getInitials = name => {
        if (!name) return "PG";
        return name
            .split(" ")
            .filter(Boolean)
            .map(part => part[0])
            .join("")
            .substring(0, 2)
            .toUpperCase();
    };

    clampPercent = value => {
        const n = Number(value);
        if (!Number.isFinite(n)) return 0;
        return Math.max(0, Math.min(100, Math.round(n)));
    };

    computeRowMetrics = row => {
        const behind = Number(row?.goals_behind) || 0;
        const atRisk = Number(row?.goals_at_risk) || 0;
        const onTrack = Number(row?.goals_on_track) || 0;
        const achieved = Number(row?.goals_achieved) || 0;
        const total = behind + atRisk + onTrack + achieved;

        if (total <= 0) {
            return {
                total: 0,
                behind,
                atRisk,
                onTrack,
                achieved,
                behindPct: 0,
                atRiskPct: 0,
                onTrackPct: 0,
                completionPct: 0
            };
        }

        return {
            total,
            behind,
            atRisk,
            onTrack,
            achieved,
            behindPct: this.clampPercent((behind / total) * 100),
            atRiskPct: this.clampPercent((atRisk / total) * 100),
            onTrackPct: this.clampPercent((onTrack / total) * 100),
            completionPct: this.clampPercent((achieved / total) * 100)
        };
    };

    renderCircle = ({ percent, variant, label }) => {
        const pct = this.clampPercent(percent);
        const progressDeg = `${pct * 3.6}deg`;

        return (
            <div className={`users-goal-badge users-goal-badge-${variant}`}>
                <div
                    className={`users-goal-circle users-goal-circle-${variant}`}
                    style={{ "--progress": progressDeg }}
                >
                    <div className="users-goal-circle-inner">{pct}%</div>
                </div>
                <div className="users-goal-circle-label">{label}</div>
            </div>
        );
    };

    fetchGoalsForSelectedEmployeeCycle = (page = this.state.currentPage, perPage = this.state.perPage) => {
        const { selectedTimeframe, searchQuery, selectedCategory } = this.state;

        if (!selectedTimeframe || !selectedTimeframe.id) return;

        this.setState({ isLoadingUsers: true });

        axios
            .post(`${Cookies.get("apiEnv")}/goals/goal_cycle_table_list`, {
                goal_setting_id: selectedTimeframe.id,
                page,
                per_page: perPage,
                search: searchQuery || "",
                ...(selectedCategory?.id ? { question_category_id: selectedCategory.id } : {})
            })
            .then(response => {
                const data = response?.data || {};
                const users = data?.users || [];

                const employeeSummary = users?.map(item => {
                    const imageUrl = item?.image?.url || item?.image;
                    const userId = item?.id || item?.user_id || item?.user?.id || item?.human_friendly_id;

                    return {
                        id: userId,
                        userId: userId,
                        name: item?.full_name,
                        image: imageUrl,
                        goals_behind: item?.goals_behind,
                        goals_at_risk: item?.goals_at_risk,
                        goals_on_track: item?.goals_on_track,
                        goals_achieved: item?.goals_achieved,
                        achieved_goals: item?.achieved_goals
                    };
                });            

                const totalUsers = Number.isFinite(data?.total_count) ? data.total_count : users.length;
                const perPageValue = Number.isFinite(data?.per_page) ? data.per_page : perPage;
                const currentPageValue = Number.isFinite(data?.current_page) ? data.current_page : page;
                const totalPages =
                    Number.isFinite(data?.total_pages) && data.total_pages > 0
                        ? data.total_pages
                        : perPageValue > 0
                            ? Math.max(1, Math.ceil(totalUsers / perPageValue))
                            : 1;

                this.setState({
                    employeeSummary,
                    isLoadingUsers: false,
                    totalUsers,
                    totalPages,
                    currentPage: currentPageValue,
                    perPage: perPageValue,
                    goalInfoCardSummary: {
                        totalEmployees: Number(data.total_employees) || 0,
                        totalGoals: Number(data.total_goals) || 0,
                        employeesWithoutGoals:
                            Number(data.employees_without_goals) || 0,
                        employeesGoalsNotUpdated:
                            Number(data.employees_goals_not_updated) || 0
                    }
                });
            })
            .catch(error => {
                console.error("Failed to load goal cycle table list", error);
                this.setState({
                    error: "Failed to load users for this goal cycle",
                    employeeSummary: [],
                    totalUsers: 0,
                    totalPages: 0,
                    isLoadingUsers: false,
                    goalInfoCardSummary: {
                        totalEmployees: 0,
                        totalGoals: 0,
                        employeesWithoutGoals: 0,
                        employeesGoalsNotUpdated: 0
                    }
                });
            });
    };

    handleSelectGoalCycle = timeframe => {
        this.setState(
            {
                selectedTimeframe: timeframe,
                isDropdownOpen: false,
                currentPage: 1
            },
            () => {
                this.fetchGoalsForSelectedEmployeeCycle();
            }
        );
    };

    handlePageChange = pageNumber => {
        this.setState({ currentPage: pageNumber }, () => {
            this.fetchGoalsForSelectedEmployeeCycle(pageNumber);
        });
    };

    handlePerPageChange = event => {
        const perPage = parseInt(event.target.value, 10) || 10;
        this.setState({ perPage, currentPage: 1 }, () => {
            this.fetchGoalsForSelectedEmployeeCycle(1, perPage);
        });
    };

    renderPagination = () => {
        const { totalUsers, perPage, currentPage, totalPages, isLoadingUsers, employeeSummary } = this.state;

        if (isLoadingUsers || employeeSummary.length === 0 || totalUsers === 0) return null;

        return (
            <Flexbox justifyContent="space-between" marginTop="16px" alignItems="center" flexDirection="row">

                <Flexbox flexDirection="column" alignItems="center">
                    <Pagination
                        activePage={currentPage}
                        itemsCountPerPage={perPage}
                        totalItemsCount={totalUsers}
                        pageRangeDisplayed={Math.min(5, totalPages || 5)}
                        onChange={this.handlePageChange}
                        disabledClass="bp3-disabled"
                        innerClass="bp3-button-group bp3-minimal bp3-pagination"
                        itemClass="bp3-button"
                        activeClass="bp3-active bp3-pagination-active"
                        linkClass="no-underline"
                        prevPageText={<span className="bp3-icon-chevron-left"> </span>}
                        nextPageText={<span className="bp3-icon-chevron-right"> </span>}
                        firstPageText={<span className="bp3-icon-double-chevron-left"> </span>}
                        lastPageText={<span className="bp3-icon-double-chevron-right"> </span>}
                    />
                </Flexbox>
                <Flexbox alignItems="center">
                    <span className="table-header-text" style={{ marginRight: 8 }}>
                        Show
                    </span>
                    <select
                        value={perPage}
                        onChange={this.handlePerPageChange}
                        className="bp3-input"
                        style={{ width: 80, marginRight: 8 }}
                    >
                        {[10, 25, 40, 100].map(size => (
                            <option key={size} value={size}>
                                {size}
                            </option>
                        ))}
                    </select>
                    <span className="table-header-text">per page</span>
                </Flexbox>
            </Flexbox>
        );
    };

    toggleUserSelection = userId => {
        this.setState(prev => ({
            selectedUsers: prev.selectedUsers.includes(userId)
                ? prev.selectedUsers.filter(id => id !== userId)
                : [...prev.selectedUsers, userId]
        }));
    };

    toggleSelectAll = () => {
        const allIds = this.state.employeeSummary.map(u => u.userId);

        this.setState(prev => ({
            selectedUsers:
                prev.selectedUsers.length === allIds.length
                    ? []
                    : allIds
        }));
    };

    sendSelectedReminder = () => {
        this.setState({ isSendingMails: true });
        if (this.state.selectedUsers.length === 0) {
            ToastStore?.showToast?.("Please select at least one user", "danger");
            this.setState({ isSendingMails: false });
            return;
        }
        axios.post(`${Cookies.get("apiEnv")}/goals/send_notification`, {
            user_ids: this.state.selectedUsers
        }).then(response => {
            ToastStore?.showToast?.(response?.data?.message || "Reminder emails sent successfully", "success");
            this.setState({ isSendingMails: false });
        }).catch(error => {
            this.setState({ isSendingMails: false });
            ToastStore?.showToast?.(error?.response?.data?.error || "Failed to send reminder emails", "danger");
        });
    };
    sendReminderToManager = () => {
        this.setState({ isSendingMails: true });
        axios.post(`${Cookies.get("apiEnv")}/goals/send_notification/manager`, {
            user_ids: this.state.selectedUsers
        }).then(response => {
            ToastStore?.showToast?.(response?.data?.message || "Reminder emails sent successfully", "success");
            this.setState({ isSendingMails: false });
        }).catch(error => {
            this.setState({ isSendingMails: false });
            ToastStore?.showToast?.(error?.response?.data?.error || "Failed to send reminder emails", "danger");
        });

    };

    render() {
        const {
            searchQuery,
            employeeSummary,
            selectedTimeframe,
            goalCycleList,
            isLoadingUsers,
            isLoadingCycles,
            error,
            goalInfoCardSummary
        } = this.state;
        const allGoalCycles = goalCycleList || [];
        const summaryCards = [
            {
                keyName: "total_employees",
                title: "Total Employees",
                data: goalInfoCardSummary.totalEmployees || 0,
                icon: TotalEmployees
            },
            {
                keyName: "total_goals",
                title: "Total Goals",
                data: goalInfoCardSummary.totalGoals || 0,
                icon: TotalGoals
            },
            {
                keyName: "employees_without_goals",
                title: "Employees Without Goals",
                data: goalInfoCardSummary.employeesWithoutGoals || 0,
                icon: EmployeeWithoutGoal
            },
            {
                keyName: "employees_goals_not_updated",
                title: "Employees Goals Not Updated",
                data: goalInfoCardSummary.employeesGoalsNotUpdated || 0,
                icon: EmpNotUpdatedGoal
            }
        ];

        return (
            <ThemeWrapper>
                <ErrorBoundary>
                    <style>{GOAL_TABLE_STYLES}</style>

                    <Flexbox flexDirection="column" padding="20px" marginLeft="10px">
                        <div
                            style={{
                                display: "flex",
                                justifyContent: "space-between",
                                alignItems: "center",
                                width: "100%",
                                marginTop: "32px"
                            }}
                        >
                            <h3 style={{ fontSize: "20px", margin: 0 }}>
                                Users Goal Overview
                            </h3>

                            <div
                                style={{
                                    display: "flex",
                                    alignItems: "center",
                                    gap: "12px"
                                }}
                            >
                                <div style={{ width: "250px" }}>
                                    <ScrollableDropdown
                                        width={250}
                                        label={
                                            this.state.selectedCategory?.name ||
                                            "Select Category"
                                        }
                                        items={this.state.categories}
                                        getKey={c => c.id}
                                        getLabel={c => c.name}
                                        enableSearch
                                        onSelect={category =>
                                            this.setState(
                                                {
                                                    selectedCategory: category,
                                                    currentPage: 1
                                                },
                                                () =>
                                                    this.fetchGoalsForSelectedEmployeeCycle(
                                                        1,
                                                        this.state.perPage
                                                    )
                                            )
                                        }
                                        isLoading={this.state.isLoadingCategories}
                                    />
                                </div>
                                <div style={{ width: "250px" }} ref={this.goalCycleDropdownRef}>
                                    <ScrollableDropdown
                                        width={250}
                                        label={selectedTimeframe?.title || "Goal Cycle"}
                                        items={allGoalCycles}
                                        getKey={g => g.id}
                                        getLabel={g => g.title}
                                        enableSearch={true}
                                        onSelect={this.handleSelectGoalCycle}
                                    />
                                </div>

                                <div style={{ width: "250px" }}>
                                    <InputGroup
                                        leftIcon="search"
                                        large={true}
                                        placeholder="Search by users name..."
                                        value={searchQuery}
                                        onChange={this.handleSearchChange}
                                        style={{
                                            width: "100%",
                                            borderRadius: "20px",
                                            fontSize: "14px"
                                        }}
                                        inputProps={{
                                            style: {
                                                borderRadius: "20px"
                                            }
                                        }}
                                    />
                                </div>
                            </div>
                        </div>

                        <Flexbox  flexDirection="column"  className="push-20-t goal-table-container" >
                            <div className="users-goal-summary-cards">
                                {summaryCards.map(card => (
                                    <GoalTableInfoCard
                                        key={card.keyName}
                                        card={card}
                                    />
                                ))}
                            </div>                      
                            {this.state.selectedUsers.length > 0 && (
                                <div
                                    style={{
                                        marginBottom: 16,
                                        padding: "16px 20px",
                                        border: "1px solid #D8E1EA",
                                        borderRadius: 10,
                                        background: "#F8FBFF",
                                        display: "flex",
                                        justifyContent: "space-between",
                                        alignItems: "center"
                                    }}
                                >
                                    <Flexbox alignItems="center">
                                        <div
                                            style={{
                                                width: 40,
                                                height: 40,
                                                borderRadius: "50%",
                                                background: "#2D72D2",
                                                color: "#fff",
                                                display: "flex",
                                                justifyContent: "center",
                                                alignItems: "center",
                                                marginRight: 14
                                            }}
                                        >
                                            <span className="bp3-icon bp3-icon-notifications" />
                                        </div>

                                        <div>
                                            <div style={{ fontWeight: 600 }}>
                                                Send reminder emails
                                            </div>

                                            <div style={{ color: "#5C7080" }}>
                                                Nudge team members to update their goals. Selected Employees will receive the email.
                                            </div>
                                        </div>
                                    </Flexbox>

                                    <Flexbox style={{ gap: 10 }}>
                                        <OutlinedButton
                                            disabled={this.state.isSendingMails}
                                            text="Send to selected"
                                            onClick={this.sendSelectedReminder}
                                        />

                                        <Tooltip portalContainer={document.body}
                                            content="Selected Employees Manager will receive the email."
                                            position={Position.TOP}
                                            hoverOpenDelay={100}
                                            boundary="viewport"
                                        >
                                            <div style={{ display: "inline-block" }}>
                                                <FilledButton
                                                    disabled={this.state.isSendingMails}
                                                    text="Send to Managers"
                                                    onClick={this.sendReminderToManager}
                                                />
                                            </div>
                                        </Tooltip>

                                    </Flexbox>
                                </div>
                            )}

                            <div className="users-goal-table-wrapper">
                                <table
                                    className="bp3-html-table bp3-small"
                                    style={{ border: "1px solid #e5e5e5", width: "100%" }}
                                >
                                    <thead
                                        style={{
                                            backgroundColor: "rgba(189, 195, 199, 0.10)",
                                            color: "#4D4D4D"
                                        }}
                                    >
                                        <tr
                                            style={{
                                                alignContent: "center",
                                                fontSize: "18px",
                                                fontWeight: "400",
                                                lineHeight: "normal"
                                            }}
                                        >
                                            <th style={{ width: 40, textAlign: "center", verticalAlign: "middle" }}>
                                                <Checkbox
                                                    checked={
                                                        this.state.selectedUsers.length ===
                                                        this.state.employeeSummary.length &&
                                                        this.state.employeeSummary.length > 0
                                                    }
                                                    onChange={this.toggleSelectAll}
                                                />
                                            </th>
                                            <th
                                                className="table-header-text"
                                                style={{ width: "20%", padding: "12px 12px" }}
                                            >
                                                Employee
                                            </th>
                                            <th
                                                className="table-header-text"
                                                style={{ width: "20%", textAlign: "center", padding: "12px 12px" }}
                                            >
                                                Progress
                                            </th>
                                            <th
                                                className="table-header-text"
                                                style={{ width: "20%", textAlign: "center", padding: "12px 12px" }}
                                            >
                                                On Track
                                            </th>
                                            <th
                                                className="table-header-text"
                                                style={{ width: "20%", textAlign: "center", padding: "12px 12px" }}
                                            >
                                                At Risk
                                            </th>
                                            <th
                                                className="table-header-text"
                                                style={{ width: "20%", textAlign: "center", padding: "12px 12px" }}
                                            >
                                                Overdue
                                            </th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {isLoadingUsers || isLoadingCycles ? (
                                            <tr>
                                                <td colSpan={6} style={{ textAlign: "center", padding: "36px 16px" }}>
                                                    <Flexbox flexGrow={1} flexDirection="column" justifyContent="center" alignItems="center">
                                                        <img
                                                            style={{ height: "35px", width: "35px" }}
                                                            src="https://s01.live2support.com/dashboardv2/chatassets/img/loader_new.gif"
                                                            alt="Loading..."
                                                        />
                                                    </Flexbox>
                                                </td>
                                            </tr>
                                        ) : employeeSummary.length === 0 ? (
                                            <tr>
                                                <td
                                                    className="table-header-text"
                                                    colSpan={5}
                                                    style={{ textAlign: "center", padding: "16px" }}
                                                >
                                                    No data found
                                                </td>
                                            </tr>
                                        ) : (
                                            employeeSummary.map((row, index) => {
                                                const avatarSrc = row.image || this.getDefaultAvatar(row.name);
                                                const metrics = this.computeRowMetrics(row);

                                                return (
                                                    <tr
                                                        className="table-row"
                                                        key={row.userId || row.id || `row-${index}`}
                                                        style={{
                                                            cursor: "pointer",
                                                            alignContent: "center",
                                                            height: "60px",
                                                            verticalAlign: "middle"
                                                        }}
                                                        onClick={() => this.handleRowClick(row)}
                                                    >
                                                        <td
                                                            onClick={e => e.stopPropagation()}
                                                            style={{ verticalAlign: "middle" }}
                                                        >
                                                            <Checkbox
                                                                checked={this.state.selectedUsers.includes(row.userId)}
                                                                onChange={() => this.toggleUserSelection(row.userId)}
                                                            />
                                                        </td>
                                                        <td
                                                            className="table-header-text users-goal-member-cell"
                                                            style={{ verticalAlign: "middle" }}
                                                        >
                                                            <Flexbox alignItems="center">
                                                                <div
                                                                    style={{
                                                                        position: "relative",
                                                                        width: 32,
                                                                        height: 32,
                                                                        marginRight: 8
                                                                    }}
                                                                >
                                                                    <div
                                                                        style={{
                                                                            width: 32,
                                                                            height: 32,
                                                                            borderRadius: "50%",
                                                                            backgroundColor: "#e6f0ff",
                                                                            color: "#2f5ee0",
                                                                            display: "flex",
                                                                            alignItems: "center",
                                                                            justifyContent: "center",
                                                                            fontSize: 12,
                                                                            fontWeight: 600
                                                                        }}
                                                                    >
                                                                        {this.getInitials(row.name)}
                                                                    </div>
                                                                    {avatarSrc && (
                                                                        <img
                                                                            src={avatarSrc}
                                                                            alt={row.name}
                                                                            loading="lazy"
                                                                            onError={e => {
                                                                                e.target.onerror = null;
                                                                                e.target.src = this.getDefaultAvatar(row.name);
                                                                            }}
                                                                            style={{
                                                                                position: "absolute",
                                                                                top: 0,
                                                                                left: 0,
                                                                                width: 32,
                                                                                height: 32,
                                                                                borderRadius: "50%",
                                                                                objectFit: "cover"
                                                                            }}
                                                                        />
                                                                    )}
                                                                </div>
                                                                <span className="ellipsis-text">{row.name}</span>
                                                            </Flexbox>
                                                        </td>
                                                        <td
                                                            className="table-header-text"
                                                            style={{
                                                                textAlign: "center",
                                                                verticalAlign: "middle"
                                                            }}
                                                        >
                                                            {this.renderCircle({
                                                                percent: metrics.completionPct,
                                                                variant: "blue",
                                                                label: "PROGRESS"
                                                            })}
                                                        </td>
                                                        <td
                                                            className="table-header-text"
                                                            style={{
                                                                textAlign: "center",
                                                                verticalAlign: "middle"
                                                            }}
                                                        >
                                                            {this.renderCircle({
                                                                percent: metrics.onTrackPct,
                                                                variant: "green",
                                                                label: "ON TRACK"
                                                            })}
                                                        </td>
                                                        <td
                                                            className="table-header-text"
                                                            style={{
                                                                textAlign: "center",
                                                                verticalAlign: "middle"
                                                            }}
                                                        >
                                                            {this.renderCircle({
                                                                percent: metrics.atRiskPct,
                                                                variant: "orange",
                                                                label: "AT RISK"
                                                            })}
                                                        </td>
                                                        <td
                                                            className="table-header-text"
                                                            style={{
                                                                textAlign: "center",
                                                                verticalAlign: "middle"
                                                            }}
                                                        >
                                                            {this.renderCircle({
                                                                percent: metrics.behindPct,
                                                                variant: "red",
                                                                label: "OVERDUE"
                                                            })}
                                                        </td>
                                                    </tr>
                                                );
                                            })
                                        )}
                                    </tbody>
                                </table>
                            </div>
                        </Flexbox>
                        {this.renderPagination()}
                    </Flexbox>
                </ErrorBoundary>
            </ThemeWrapper>
        );
    }
}
